import { returnAction } from '../return-action.util';
import { ActionEnum } from '../../../enum/action.enum';
import {IHttpUpdateGlobalErrorSettingsPayload} from '../../../action/http.action';

export const httpUpdateGlobalErrorSettings = (payload: IHttpUpdateGlobalErrorSettingsPayload) => returnAction<IHttpUpdateGlobalErrorSettingsPayload>(ActionEnum.HTTP_UPDATE_GLOBAL_ERROR_SETTINGS, payload);
